// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for the ping monitor */
.ping-container {
  font-family:'Siyam Rupali', sans-serif;
  padding: 10px;
  background-color: #f7f7fa;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: 0 auto;
}

.ping-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 10px;
}

.ping-input-area {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.ping-ip-input {
  padding: 10px;
  width: 50%;
  max-width: 600px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.ping-btn {
  padding: 5px 5px;
  margin-left: 5px;
  font-size: 6px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.green { background-color: #4CAF50;  color: white; }
.red { background-color: #f44336;  color: white; }
.yellow { background-color: #FFEB3B;  color: black; }
.blue { background-color: #2196F3;  color: white; }

.ping-status { 
  text-align: center;  
  margin-top: 20px;  
  font-size: 16px;  
  color: #555; 
}

.ping-logs-wrapper { margin-top: 20px; }

.log-box { 
  margin-bottom: 10px;  
  background-color: white;  
  padding: 15px;  
  border-radius: 5px;  
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); 
}

.ping-log-title { 
  font-weight: bold;  
  font-size: 12px;  
  margin-bottom: 10px; 
}

.ping-info { 
  display: block;  
  margin-top: 5px;  
  font-size: 12px;  
  color: #888; 
}

.ping-log-body { 
  max-height: 200px;  
  overflow-y: auto;  
  font-family: monospace;  
  font-size: 12px;  
  color: #333; 
}

.ping-log-body div { margin-bottom: 5px; }

/* Desktop view */
@media (min-width: 1024px) { 
  .ping-container { padding: 30px; }
  .ping-input-area { justify-content: space-between; }
  .ping-ip-input { width: 50%; }
  .ping-btn { font-size: 16px; padding: 12px 25px; max-width: 100px}
  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .ping-log-title { font-size: 18px; }
}

/* Tablet view */
@media (min-width: 768px) and (max-width: 1023px) { 
  .ping-ping-container { padding: 30px; }
  .ping-input-area { flex-direction: column; align-items: center; }
  .ping-ip-input { width: 70%; margin-bottom: 10px; }
  .ping-btn { font-size: 14px; padding: 10px 20px; margin-bottom: 5px; }
  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr; gap: 20px; }
  .ping-log-title { font-size: 16px; }
}

/* Mobile view */
@media (max-width: 767px) { 
  .ping-ping-container { padding: 15px; }
  .ping-input-area { flex-direction: column; align-items: center; }
  .ping-ip-input { width: 100%; margin-bottom: 15px; }
  .ping-btn { width: 100%; margin-bottom: 10px; font-size: 14px; padding: 8px 15px; }
  .ping-status { font-size: 14px; }
  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr; gap: 15px; }
  .ping-log-box { display: flex; flex-direction: column; align-items: flex-start; }
  .ping-log-title { font-size: 14px; }
  .ping-ping-info { font-size: 12px; }
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/PingMonitor.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,SAAS,yBAAyB,GAAG,YAAY,EAAE;AACnD,OAAO,yBAAyB,GAAG,YAAY,EAAE;AACjD,UAAU,yBAAyB,GAAG,YAAY,EAAE;AACpD,QAAQ,yBAAyB,GAAG,YAAY,EAAE;;AAElD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB,kBAAkB,EAAE;;AAEzC,iBAAiB;AACjB;EACE,kBAAkB,aAAa,EAAE;EACjC,mBAAmB,8BAA8B,EAAE;EACnD,iBAAiB,UAAU,EAAE;EAC7B,YAAY,eAAe,EAAE,kBAAkB,EAAE,gBAAgB;EACjE,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;EAC/E,kBAAkB,eAAe,EAAE;AACrC;;AAEA,gBAAgB;AAChB;EACE,uBAAuB,aAAa,EAAE;EACtC,mBAAmB,sBAAsB,EAAE,mBAAmB,EAAE;EAChE,iBAAiB,UAAU,EAAE,mBAAmB,EAAE;EAClD,YAAY,eAAe,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;EACrE,qBAAqB,aAAa,EAAE,0BAA0B,EAAE,SAAS,EAAE;EAC3E,kBAAkB,eAAe,EAAE;AACrC;;AAEA,gBAAgB;AAChB;EACE,uBAAuB,aAAa,EAAE;EACtC,mBAAmB,sBAAsB,EAAE,mBAAmB,EAAE;EAChE,iBAAiB,WAAW,EAAE,mBAAmB,EAAE;EACnD,YAAY,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE,iBAAiB,EAAE;EAClF,eAAe,eAAe,EAAE;EAChC,qBAAqB,aAAa,EAAE,0BAA0B,EAAE,SAAS,EAAE;EAC3E,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE;EAChF,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,eAAe,EAAE;AACrC","sourcesContent":["/* Base styles for the ping monitor */\n.ping-container {\n  font-family:'Siyam Rupali', sans-serif;\n  padding: 10px;\n  background-color: #f7f7fa;\n  border-radius: 10px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.ping-title {\n  text-align: center;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.ping-input-area {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.ping-ip-input {\n  padding: 10px;\n  width: 50%;\n  max-width: 600px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.ping-btn {\n  padding: 5px 5px;\n  margin-left: 5px;\n  font-size: 6px;\n  cursor: pointer;\n  border: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.green { background-color: #4CAF50;  color: white; }\n.red { background-color: #f44336;  color: white; }\n.yellow { background-color: #FFEB3B;  color: black; }\n.blue { background-color: #2196F3;  color: white; }\n\n.ping-status { \n  text-align: center;  \n  margin-top: 20px;  \n  font-size: 16px;  \n  color: #555; \n}\n\n.ping-logs-wrapper { margin-top: 20px; }\n\n.log-box { \n  margin-bottom: 10px;  \n  background-color: white;  \n  padding: 15px;  \n  border-radius: 5px;  \n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); \n}\n\n.ping-log-title { \n  font-weight: bold;  \n  font-size: 12px;  \n  margin-bottom: 10px; \n}\n\n.ping-info { \n  display: block;  \n  margin-top: 5px;  \n  font-size: 12px;  \n  color: #888; \n}\n\n.ping-log-body { \n  max-height: 200px;  \n  overflow-y: auto;  \n  font-family: monospace;  \n  font-size: 12px;  \n  color: #333; \n}\n\n.ping-log-body div { margin-bottom: 5px; }\n\n/* Desktop view */\n@media (min-width: 1024px) { \n  .ping-container { padding: 30px; }\n  .ping-input-area { justify-content: space-between; }\n  .ping-ip-input { width: 50%; }\n  .ping-btn { font-size: 16px; padding: 12px 25px; max-width: 100px}\n  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }\n  .ping-log-title { font-size: 18px; }\n}\n\n/* Tablet view */\n@media (min-width: 768px) and (max-width: 1023px) { \n  .ping-ping-container { padding: 30px; }\n  .ping-input-area { flex-direction: column; align-items: center; }\n  .ping-ip-input { width: 70%; margin-bottom: 10px; }\n  .ping-btn { font-size: 14px; padding: 10px 20px; margin-bottom: 5px; }\n  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr; gap: 20px; }\n  .ping-log-title { font-size: 16px; }\n}\n\n/* Mobile view */\n@media (max-width: 767px) { \n  .ping-ping-container { padding: 15px; }\n  .ping-input-area { flex-direction: column; align-items: center; }\n  .ping-ip-input { width: 100%; margin-bottom: 15px; }\n  .ping-btn { width: 100%; margin-bottom: 10px; font-size: 14px; padding: 8px 15px; }\n  .ping-status { font-size: 14px; }\n  .ping-logs-wrapper { display: grid; grid-template-columns: 1fr; gap: 15px; }\n  .ping-log-box { display: flex; flex-direction: column; align-items: flex-start; }\n  .ping-log-title { font-size: 14px; }\n  .ping-ping-info { font-size: 12px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
